import { useEffect, useState } from "react";

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // Show button after scrolling 300px
      setVisible(window.pageYOffset > 300);
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {visible && (
        <button type="button" className="scroll-top-btn" onClick={scrollToTop} aria-label="Scroll to top" >
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="29" viewBox="0 0 22 29" fill="none">
            <path d="M21.6882 10.7369C22.1039 11.1725 22.1039 11.8787 21.6882 12.3143C21.2725 12.7499 20.5985 12.7499 20.1828 12.3143L11 2.69274L1.81724 12.3143C1.40152 12.7499 0.727503 12.7499 0.311784 12.3143C-0.103921 11.8787 -0.10393 11.1725 0.311784 10.7369L10.2473 0.326685C10.663 -0.108893 11.337 -0.108897 11.7527 0.326685L21.6882 10.7369Z" fill="white" />
            <path d="M12.0645 27.8846C12.0645 28.5006 11.5879 29 11 29C10.4121 29 9.93549 28.5006 9.93549 27.8846L9.93549 1.11538C9.93549 0.499375 10.4121 1.43505e-07 11 1.36495e-07C11.5879 1.29484e-07 12.0645 0.499375 12.0645 1.11538L12.0645 27.8846Z" fill="white" />
          </svg>
        </button>
      )}
    </>
  );
}